import { render, staticRenderFns } from "./LeaderboardDisplay.vue?vue&type=template&id=099a903a&scoped=true&lang=html&"
import script from "./LeaderboardDisplay.vue?vue&type=script&lang=js&"
export * from "./LeaderboardDisplay.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardDisplay.vue?vue&type=style&index=0&id=099a903a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099a903a",
  null
  
)

export default component.exports